"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectSettingType = exports.ProjectClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class ProjectClient extends authenticated_client_1.AuthenticatedClient {
    getAll(fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects?` + this.getQueryString({ fields });
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    search(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = new URLSearchParams();
            for (const [key, value] of Object.entries(request)) {
                params.append(key, value);
            }
            const url = `/v1/projects?${params}`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    get(id, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const fields = options instanceof Array ? options : options === null || options === void 0 ? void 0 : options.fields;
            const response = yield this.httpGet(`/v1/projects/${id}?` + this.getQueryString({ fields }));
            return response.payload;
        });
    }
    create(project) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects`, project);
            return response.payload;
        });
    }
    update(project) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = project.id;
            if (!projectId) {
                throw new Error('Project id not provided.');
            }
            delete project.id;
            const response = yield this.httpPut(`/v1/projects/${projectId}`, project);
            return response.payload;
        });
    }
    updateStatus(id, updateProjectStatusRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${id}/status`, updateProjectStatusRequest);
            return response.payload;
        });
    }
    getFlags(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/flags`, {
                throwOnError: false,
            });
            if (response.success) {
                return response.payload;
            }
        });
    }
    updateFlags(projectId, flags) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/flags`, flags);
            return response.payload;
        });
    }
    setFlags(projectId, flags) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/flags`, flags);
            return response.payload;
        });
    }
    getUsers(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/users`);
            return response.payload;
        });
    }
    getSettings(projectId, settingType, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/${settingType}-settings?${this.getQueryString({ fields })}`, { throwOnError: false });
            if (response.success) {
                return response.payload;
            }
        });
    }
    getPreviewUrls(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/preview-urls`, { throwOnError: false });
            if (response.success) {
                return response.payload;
            }
        });
    }
    setSettings(projectId, settingType, settings) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/${settingType}-settings`, settings);
            return response.payload;
        });
    }
    updateSettings(projectId, settingType, settings) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/${settingType}-settings`, settings);
            return response.payload;
        });
    }
    getPathComputationSettingsHistory(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/path-computation-history`);
            return response.payload;
        });
    }
    getPublicKey(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/public-key`);
            return response.payload;
        });
    }
    savePublicKey(projectId, publicKeyValue) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/public-key`, { publicKeyValue });
            return response.payload;
        });
    }
    updatePersistencyEnabled(projectId, persistencyEnabled) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/projects/${projectId}/public-key`, { persistencyEnabled });
            return response.payload;
        });
    }
    getApiErrorAdditionalDataSettings(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/api-error-additional-data`);
            return response.payload;
        });
    }
    setApiErrorAdditionalDataSettings(projectId, apiErrorAdditionalData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/api-error-additional-data`, apiErrorAdditionalData);
            return response.payload;
        });
    }
    createApiErrorAdditionalDataUrlSettings(projectId, url) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/api-error-additional-data-url`, { url });
            return response.payload;
        });
    }
    updateApiErrorAdditionalDataUrlSettings(projectId, urlToUpdate) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { id, url } = urlToUpdate;
            const response = yield this.httpPut(`/v1/projects/${projectId}/api-error-additional-data-url/${id}`, {
                url,
            });
            return response.payload;
        });
    }
    deleteApiErrorAdditionalDataUrlSettings(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v1/projects/${projectId}/api-error-additional-data-url/${id}`);
            return response.payload;
        });
    }
    getLatestTagSnapshot(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/tag-snapshots/latest`, {
                throwOnError: false,
            });
            if (response.success) {
                return response.payload;
            }
        });
    }
    buildTagSnapshot(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/dcb/snapshot/${projectId}/build`);
            return response.payload;
        });
    }
    buildPreviewTag(previewRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/dcb/build/preview`, previewRequest);
            return response.payload;
        });
    }
    getSdkSettingsV2(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/${projectId}/sdk-settings`, { throwOnError: false });
            if (response.success) {
                return response.payload;
            }
        });
    }
    getSdkProjectPackage(os, packageName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/packages/${os}/${packageName}`, { throwOnError: false });
            return response.payload;
        });
    }
    updateSdkSettingsV2(projectId, settings) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            settings = Object.assign(Object.assign({}, settings), { id: undefined, createdAt: undefined, updatedAt: undefined, deletedAt: undefined, creatorId: undefined, updaterId: undefined, salesforceId: undefined, project: undefined });
            const response = yield this.httpPut(`/v2/projects/${projectId}/sdk-settings`, settings);
            return response.payload;
        });
    }
    findProjectSessionReplayConfig(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const path = this.sdkSessionReplayConfigPath(projectId);
            const response = yield this.httpGet(path);
            return response.payload;
        });
    }
    updateProjectSessionReplayConfig(projectId, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const path = this.sdkSessionReplayConfigPath(projectId);
            const response = yield this.httpPut(path, body);
            return response.payload;
        });
    }
    renew(projectId, collectionDuration) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/demos/${projectId}/renew?${this.getQueryString({ collectionDuration })}`, {});
            return response.payload;
        });
    }
    convertFromDemo(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/demos/${projectId}/convert`);
            return response.payload;
        });
    }
    getProxySettingsById(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/proxy-settings`);
            return response.payload;
        });
    }
    getIndustriesForProject(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/industries`);
            return response.payload;
        });
    }
    getAccountForProject(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/account`);
            return response.payload;
        });
    }
    getAmwTheme(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/theme`);
            return response.payload;
        });
    }
    putAmwTheme(projectId, theme) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/theme`, theme);
            return response.payload;
        });
    }
    sdkSessionReplayConfigPath(projectId) {
        return `/v2/projects/${projectId}/session-replay-config`;
    }
}
exports.ProjectClient = ProjectClient;
var ProjectSettingType;
(function (ProjectSettingType) {
    ProjectSettingType["Tag"] = "tag";
})(ProjectSettingType = exports.ProjectSettingType || (exports.ProjectSettingType = {}));
//# sourceMappingURL=project.client.js.map